export default __webpack_public_path__ + "media/images/tennisball-dog-4572395cd1fc522b261431fe99c82b25.png";